import { getRequestInfoList, creatRequestInfoFile, downloadRequestInfoFile } from "./BiGSMBIBIO01/GSMBIBIO01Reducer";

export const smReducer = {
    getRequestInfoList,
    creatRequestInfoFile,
    downloadRequestInfoFile
};
